import React from 'react'
import { BarChart, Bar, ResponsiveContainer, XAxis, YAxis, CartesianGrid, Tooltip, Label } from 'recharts';

const mockData = [
    {
        name: 'Page A',
        uv: 4000,
        pv: 2400,
        amt: 2400,
    },
    {
        name: 'Page B',
        uv: 3000,
        pv: 1398,
        amt: 2210,
    },
    {
        name: 'Page C',
        uv: 2000,
        pv: 9800,
        amt: 2290,
    },
    {
        name: 'Page D',
        uv: 2780,
        pv: 3908,
        amt: 2000,
    },
    {
        name: 'Page E',
        uv: 1890,
        pv: 4800,
        amt: 2181,
    },
    {
        name: 'Page F',
        uv: 2390,
        pv: 3800,
        amt: 2500,
    },
    {
        name: 'Page G',
        uv: 3490,
        pv: 4300,
        amt: 2100,
    },
];

const CustomTooltip = ({ active, payload, label }) => {
    const dataKey = payload?.[0]?.['dataKey']
    if (active && payload && payload.length) {
        return (
            <div style={{ display: 'flex', flexDirection: 'column', background: '#fff', padding: 10 }}>
                <div style={{ color: "#33ABDA" }}>{`${payload[0]['payload']['sector']}`}:{`${payload[0]['payload'][dataKey]}`}</div>
            </div>
        );
    }

    return null;
};

function CustomBarChart({ data = mockData, barKey, yAxisTitle }) {
    const dataLength = data.length === 1 ? 250 : 100
    return (
        <div style={{ width: "100%", height: "300px", overflowY: "auto", position: 'relative' }}>
            <div style={{ width: '100%', height: `${data.length * dataLength}px`, position: 'absolute', bottom: 0 }}>
                <ResponsiveContainer width="100%" height="100%">
                    <BarChart
                        width={'100%'}
                        height={'100%'}
                        data={data}
                        margin={{
                            top: 5,
                            right: 30,
                            left: 20,
                            bottom: 5,
                        }}
                    >
                        <CartesianGrid horizontal={true} vertical={false} />
                        <XAxis tickLine={false} dataKey="sector" />
                        <YAxis axisLine={false} tickLine={false} label={{ value: yAxisTitle, angle: -90, position: 'insideLeft', fontWeight: 'bold', dy: 70, offset: 0 }} />
                        <Bar dataKey={barKey} fill="#33ABDA" barSize={36.6} />
                        <Tooltip content={CustomTooltip} cursor={false} />
                    </BarChart>
                </ResponsiveContainer>
            </div>
        </div>
    );
}

export default CustomBarChart
